import React, { useEffect, useState, useMemo, useCallback } from "react";
import { EquipmentsContext } from "./context";
import { withApollo } from "react-apollo";
import { DEFAULT_MYLAB_FILTER } from "../../constants";
import { getLPMyLabFilter } from '../equipment-list/LoadEquipmentService';

const EquipmentsWrapper = ({ children, client }) => {
  const [myLabEquipment, setMyLabEquipment] = useState([]);
  const [myLabFiltersList, setMyLabFiltersList] = useState([]);
  const [myLabCountInitial, setMyLabCountInitial] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState(DEFAULT_MYLAB_FILTER);
  const [userID, setUserID] = useState(null);
  const [isEdit, setEdit] = useState(false);

  useEffect(() => {
    inititateMyLabEquipment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inititateMyLabEquipment = async () => {
    const myLabfilters = await fetchingMyLabEquipment();
    if (myLabfilters !== undefined) {
      if (typeof myLabfilters?.filterDefinition === "string") {
        myLabfilters.filterDefinition = JSON.parse(myLabfilters.filterDefinition);
      }
      if (
        myLabfilters?.filterDefinition?.inventoryIds !== undefined &&
        myLabfilters?.filterDefinition?.inventoryIds &&
        myLabfilters?.filterDefinition?.inventoryIds.length > 0
      ) {
        setMyLabEquipment(myLabfilters?.filterDefinition?.inventoryIds);
      }
    }
    if (myLabfilters) setMyLabFiltersList([myLabfilters]);
  };

  const fetchingMyLabEquipment = useCallback(async () => {
    return await getLPMyLabFilter(client, setUserID);
  }, [client]);

  const value = useMemo(() => ({
    myLabEquipment,
    setMyLabEquipment,
    myLabFiltersList,
    setMyLabFiltersList,
    appliedFilter,
    setAppliedFilter,
    isEdit,
    setEdit,
    myLabCountInitial,
    setMyLabCountInitial,
    fetchingMyLabEquipment,
    userID,
  }), [myLabEquipment, myLabFiltersList, appliedFilter, isEdit, myLabCountInitial, fetchingMyLabEquipment, userID]);

  return (
    <EquipmentsContext.Provider value={value}>
      {children}
    </EquipmentsContext.Provider>
  );
};

export default withApollo(EquipmentsWrapper);
